module.exports = __webpack_public_path__ + "static/img/49.98bf2b07.jpeg";